import { Stack, Typography } from "@mui/material";
import { type FC, useMemo } from "react";
import { type DisplayPerson, DisplayPersons } from "./display-person";

export const PollResponders: FC<{
  persons: DisplayPerson[];
  selectedAnswers: string[];
}> = ({ persons, selectedAnswers }) => {
  const respondersLabel = `${persons.length} response${persons.length === 1 ? "" : "s"} for`;

  // ensure the set of answers makes english sense, so the last one has an "and" before it
  // and the rest are comma separated.
  const answersString = useMemo(() => {
    // this component is only mounted when  selectedAnswers is not empty
    if (selectedAnswers.length === 0) {
      return "";
    }
    if (selectedAnswers.length === 1) {
      return selectedAnswers[0];
    }
    const lastAnswer = selectedAnswers[selectedAnswers.length - 1];
    const otherAnswers = selectedAnswers.slice(0, -1);
    return `${otherAnswers.join(", ")} and ${lastAnswer}`;
  }, [selectedAnswers]);

  return (
    <>
      <Stack direction="row" sx={{ marginBottom: 1, alignItems: "center", paddingY: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {respondersLabel}
        </Typography>
        <Typography variant="body2" color="text.secondary" fontWeight={700} marginLeft={0.5}>
          {answersString}
        </Typography>
      </Stack>
      <DisplayPersons persons={persons} />
    </>
  );
};
